/* eslint-disable import/no-cycle */
import { all, call } from 'redux-saga/effects';
import authenticationSaga from './handlers/authenticationHandler';
import userSaga from './handlers/userHandler';
import ProfileSaga from './handlers/profileHandler';
import paymentSaga from './handlers/paymentHandler';
import packageSaga from './handlers/packageHandler';
import masterSaga from './handlers/masterHandler';
import sourceSaga from './handlers/sourceHandler';
import salesAgentSaga from './handlers/salesAgentHandler';
import packageSourceSaga from './handlers/packageSourceHandler';
import merchantRegistrationSaga from './handlers/merchantRegistrationHandler';
import merchantListSaga from './handlers/merchantListHandler';
import referralSaga from './handlers/referralHandler';

export default function* rootSaga() {
  yield all([
    call(authenticationSaga),
    call(userSaga),
    call(ProfileSaga),
    call(paymentSaga),
    call(packageSaga),
    call(masterSaga),
    call(sourceSaga),
    call(salesAgentSaga),
    call(packageSourceSaga),
    call(merchantRegistrationSaga),
    call(merchantListSaga),
    call(referralSaga),
  ]);
}
